<template>
  <div class="onboarding-info-section">
    <div class="onboarding-info-header">
      <div class="onboarding-info-inner">
        <img class="onboarding-bg" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/onboarding_title_bg.png" alt="">
        <div class="onboarding-title-content">
          <div class="onboarding-bot">
            <!-- <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/onboarding_title_bot.png" alt=""> -->
             <img width="32" src="../../../assets/ai/ai_bot_avatar.png" alt="">
          </div>
          <div class="onboarding-title">{{configAi.onboardingTitle}}</div>
        </div>
      </div>
    </div>
    <div class="onboarding-info-list">
      <div class="onboarding-list scrollbar-width-none" v-if="onboardingInfo.suggested_questions">
        <div class="onboarding-list-item" v-for="suggest in onboardingInfo.suggested_questions" :key="suggest" @click="onSuggest(suggest)">{{suggest}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      onboardingInfo: {
        type: Object,
        default: () => ({
          prologue: "",
          suggested_questions: []
        })
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['configAi'])
    },
    methods: {
      onSuggest(text) {
        this.$emit('send', text)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .onboarding-info-section {
    width: 100%;
    padding-top: 16px;
  }
  .onboarding-info-header {
    width: 266px;
    height: 35px;
    margin: 0 auto;
    .onboarding-info-inner {
      width: 100%;
      height: 100%;
      position: relative;
      .onboarding-bg {
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
      .onboarding-title-content {
        display: flex;
        align-items: center;
        padding-left: 5px;
      }
      .onboarding-bot {
        width: 35px;
        height: 35px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          display: block;
        }
      }
      .onboarding-title {
        flex: 1;
        font-weight: bold;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        position: relative;
        line-height: 35px;
      }
    }
  }
  .onboarding-info-list {
    padding-top: 20px;
    .onboarding-list {
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      .onboarding-list-item {
        display: inline-block;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0,0,0,0.65);
        padding: 8px 12px;
        border-radius: 5px;
        border: 1px solid rgba(0,0,0,0.1);
        margin-right: 12px;
        background: #FFFFFF;
        line-height: 1.2;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
</style>